import { Button, Col, Image, Row, Table } from "react-bootstrap";
import { Navigate, useParams } from "react-router-dom";

import Bram2019 from "../../data/en/bramprimipassi/2020.json";
import Bram2020 from "../../data/en/bram/2020.json";
import Bram2021 from "../../data/en/bram/2021.json";
import Brichet2021 from "../../data/en/brichet/2021.json";
import Brichet2022 from "../../data/en/brichet/2022.json";
import BrichetOld from "../../data/en/brichet/1984-1995.json";
import React from "react";
import Sialic2019 from "../../data/en/sialicesperienzadibotte/2020.json";
import Sialic2020 from "../../data/en/sialic/2020.json";
import Sialic2021 from "../../data/en/sialic/2021.json";
import Sialic2022 from "../../data/en/sialicespressionidibucce/2022.json";
import SialicOld from "../../data/en/sialic/2018-2019.json";
import Tan2020 from "../../data/en/tan/2020.json";

const WineChapter = ({ title, text }) => {
	return (
		<Row>
			<h3>{title}</h3>
			<p>
				<span dangerouslySetInnerHTML={{ __html: text }} />
			</p>
		</Row>
	);
};

export const Wine = () => {
	const Wines = {
		bramprimipassi: {
			2020: Bram2019,
		},
		bram: {
			2020: Bram2020,
			2021: Bram2021,
		},
		brichet: {
			19841995: BrichetOld,
			2021: Brichet2021,
			2022: Brichet2022,
		},
		sialicesperienzadibotte: {
			2020: Sialic2019
		},
		sialicespressionidibucce: {
			2022: Sialic2022,
		},
		sialic: {
			20182019: SialicOld,
			2020: Sialic2020,
			2021: Sialic2021,
		},
		tan: {
			2020: Tan2020
		}
	};

	let { nome, anno } = useParams();
	if (nome === null || nome === undefined || nome === "") {
		return <Navigate to={"/"} />;
	}
	if (anno === null || anno === undefined || anno === "") {
		return <Navigate to={"/wines/" + nome} />;
	}
	if (!Wines.hasOwnProperty(nome)) {
		return <Navigate to={"/wines"} />;
	}
	if (!Wines[nome].hasOwnProperty(anno)) {
		return <Navigate to={"/wines/" + nome} />;
	}
	const Wine = Wines[nome][anno];

	let kitchen = "Serving temperature: " + Wine.temperature;
	if (Wine.notes !== "") {
		kitchen += "<br>Notes: " + Wine.notes;
	}
	const senses =
		"Color: " +
		Wine.color +
		"<br>Aroma: " +
		Wine.aroma +
		"<br>Taste: " +
		Wine.flavor;
	const bottle =
		"Vintage: " +
		Wine.years +
		"<br>Grape variety: " +
		Wine.grapeVariety +
		"<br>Alcohol content: " +
		Wine.alcool +
		"<br>Bottles produced: " +
		Wine.numberBottles;
	return (
		<>
			<Row>
				<Col md={12} className="text-center">
					<h2>{Wine.title} {Wine.years}</h2>
				</Col>
			</Row>
			<Row>
				<Col md={5} style={{ padding: "5vh" }} className="text-center">
					<Image
						src={Wine.image}
						style={{ maxWidth: "100%", maxHeight: "85vh" }}
					/><br />
					{Wine.ecommerceLink === "" ? <span></span> : <Button style={{ marginTop: '3vh', padding: '1vh 5vh', fontSize: '1.2em', backgroundColor: 'black', color: 'white', border: '0' }} href={Wine.ecommerceLink} target="_blank">
						Buy
					</Button>}

				</Col>
				<Col md={7} style={{ padding: "10vh" }}>
				{Wine.special !== "" ? <WineChapter title="The Story" text={Wine.special} /> : <>
    <WineChapter title="The Vineyard" text={Wine.vineyard} />
    <WineChapter title="The Harvest" text={Wine.harvest} />
    <WineChapter title="The Winemaking" text={Wine.winemaking} />
    <WineChapter title="The Wine" text={Wine.denomination} />
    <WineChapter title="The Bottle" text={bottle} />
    <WineChapter title="The Senses" text={senses} />
    <WineChapter title="In the Kitchen" text={kitchen} /></>
}
</Col>
</Row>
<Row
    style={{ backgroundColor: "black" }}
    className="justify-content-center"
>
    <Col sm={10} md={8} xl={5} style={{ padding: "5vh" }} className="text-center">
        <Table bordered style={{ color: "white" }} size="sm" responsive>
            <thead>
                <tr>
                    <th scope="col" colSpan="1">
                        COMPONENT
                    </th>
                    <th scope="col" colSpan="1">
                        CODE
                    </th>
                    <th scope="col" colSpan="1">
                        MATERIAL
                    </th>
                    <th scope="col" colSpan="1">
                        DISPOSAL
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td colSpan="1">BOTTLE</td>
                    <td colSpan="1">GL 72</td>
                    <td colSpan="1">GLASS</td>
                    <td colSpan="1">SEPARATE COLLECTION GLASS</td>
                </tr>
                <tr>
                    <td colSpan="1">CORK</td>
                    <td colSpan="1">FOR 51</td>
                    <td colSpan="1">CORK</td>
                    <td colSpan="1">SEPARATE COLLECTION DEDICATED OR ORGANIC</td>
                </tr>
                <tr>
                    <td colSpan="1">CAPSULE</td>
                    <td colSpan="1">C/ALU 90</td>
                    <td colSpan="1">POLYLAMINATE</td>
                    <td colSpan="1">SEPARATE COLLECTION METALS</td>
                </tr>
                <tr>
                    <td colSpan="4">
                        Check your municipality's regulations. Separate the components
                        and dispose of them correctly.
                    </td>
                </tr>
            </tbody>
        </Table>
    </Col>
</Row>
		</>
	);
};
